import React from 'react';

import { BlockNode, MentionNode } from '../../../types/ContentAst';
import { MentionElement } from '../mentions/MentionElement';
import { ElementProps } from '../types/slate';

export const Element = ({
  attributes,
  children,
  element,
}: ElementProps<BlockNode | MentionNode>) => {
  switch (element.type) {
    case 'mention': {
      return (
        <MentionElement
          attributes={attributes}
          children={children}
          element={element}
        />
      );
    }
    // BlockNodeType
    case 'blockquote':
    case 'h1':
    case 'h2':
    case 'li':
    case 'ol':
    case 'p':
    case 'pre':
    case 'ul':
    default: {
      const style = { textAlign: element.align };
      const ComponentType = element.type || 'p';

      return (
        <ComponentType {...attributes} element={element} style={style}>
          {children}
        </ComponentType>
      );
    }
  }
};
